import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { GetTrialBalance } from '../../store/slices/reports';
import {toast } from 'react-hot-toast';
import Loader from '../../common/Loader';
import AdminLayout from '../AdminLayout';
import {API_BASE_URL, API_PATHS } from "../../utils/constants/api.constants";

const TrialBalance = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [trialBalance, setTrialBalance] = useState([]);
  const [totaldebits, setTotaldebits] = useState([]);
  const [totalcredits, setTotalcredits] = useState([]);


  // Load saved financial year and dates from localStorage
  const loadSavedDates = () => {
    const savedFinancialYear = localStorage.getItem("selectedFinancialYear");

    // Ensure financial year is always correctly structured
    let startYear, endYear;
    if (savedFinancialYear && savedFinancialYear.includes("-")) {
      [startYear, endYear] = savedFinancialYear.split("-");
    } else {
      // Default to the current financial year
      const currentYear = new Date().getFullYear();
      startYear = currentYear - 1; // Example: 2024 (for 2024-2025)
      endYear = currentYear; // Example: 2025 (for 2024-2025)
    }

    return {
      financialYear: savedFinancialYear || `${startYear}-${endYear}`,
      fromDate: localStorage.getItem("savedFromDate") || `${startYear}-04-01`,
      toDate: localStorage.getItem("savedToDate") || `${endYear}-03-31`,
      minDate: `${startYear}-04-01`,
      maxDate: `${endYear}-03-31`,
    };
  };

  const {
    fromDate: initialFromDate,
    toDate: initialToDate,
    minDate,
    maxDate,
    financialYear: initialFinancialYear,
  } = loadSavedDates();
  
  const [fromDate, setFromDate] = useState(initialFromDate);
  const [toDate, setToDate] = useState(initialToDate);
  const [financialYear, setFinancialYear] = useState(initialFinancialYear);
  
  
  useEffect(() => {
    if (financialYear) {
      localStorage.setItem('selectedFinancialYear', financialYear);
    }
  
    const [startYear, endYear] = financialYear.split('-');
  
    // Ensure dates remain within the financial year range
    const savedFromDate = localStorage.getItem('savedFromDate') || `${startYear}-04-01`;
    const savedToDate = localStorage.getItem('savedToDate') || `${endYear}-03-31`;
  
    setFromDate(savedFromDate);
    setToDate(savedToDate);
  
    if (!localStorage.getItem('savedFromDate')) localStorage.setItem('savedFromDate', savedFromDate);
    if (!localStorage.getItem('savedToDate')) localStorage.setItem('savedToDate', savedToDate);
  }, [financialYear]);

  const user = JSON.parse(localStorage.getItem('user'));
  const Name = user?.data?.company_name;
  const profile_id = user?.data?.profile_id;

  useEffect(() => {
    handleTrialBalance();
  }, []);

  const handleTrialBalance = async () => {
    const newItem = {
      profile_id: profile_id,
      from_date: fromDate, // Ensure from_date is sent
      to_date: toDate, // Ensure to_date is sent
    };

    setIsLoading(true);

    try {
      const data = await dispatch(GetTrialBalance(newItem)).unwrap();

      setTrialBalance(data?.data?.trial_balance || []); // Update stockSummary with the response
      setTotaldebits(data?.data?.total_debits);
      setTotalcredits(data?.data?.total_credits);
    } catch (error) {
      console.error('Error fetching stock summary:', error.message);
    } finally {
      setIsLoading(false);
    }
  };


  const resetDates = async () => {
    const storedFinancialYear = localStorage.getItem('selectedFinancialYear'); // Example: "2022-2023"
    
    let startYear, endYear;
    
    if (storedFinancialYear) {
      // Extract the start and end year from stored financial year
      [startYear, endYear] = storedFinancialYear.split('-');
    } else {
      // If not found, determine the current financial year dynamically
      const today = new Date();
      startYear = today.getMonth() + 1 >= 4 ? today.getFullYear() : today.getFullYear() - 1;
      endYear = parseInt(startYear) + 1;
    }
  
    const defaultFromDate = `${startYear}-04-01`;
    const defaultToDate = `${endYear}-03-31`;
  console.log(defaultFromDate,defaultToDate)
    // Update state
    setFromDate(defaultFromDate);
    setToDate(defaultToDate);
  
   localStorage.setItem('savedFromDate', defaultFromDate);
   localStorage.setItem('savedToDate', defaultToDate);
    // Create newItem with updated financial year

    // Call handleTrialBalance with updated values directly
    const newItem = {
      profile_id: profile_id,
      from_date: defaultFromDate, // Use updated dates here
      to_date: defaultToDate, // Use updated dates here
    };

    setIsLoading(true);

    try {
      const data = await dispatch(GetTrialBalance(newItem)).unwrap();

      setTrialBalance(data?.data?.trial_balance || []); // Update stockSummary with the response
      setTotaldebits(data?.data?.total_debits);
      setTotalcredits(data?.data?.total_credits);
    } catch (error) {
      console.error('Error fetching trial balance:', error.message);
    } finally {
      setIsLoading(false);
    }
  };

  function formatDateRange(startDate, endDate) {
    const options = { day: '2-digit', month: 'long', year: 'numeric' };

    const formattedStartDate = new Date(startDate).toLocaleDateString('en-GB', options);
    const formattedEndDate = new Date(endDate).toLocaleDateString('en-GB', options);

    return `${formattedStartDate} to ${formattedEndDate}`;
  }

    const handlePDF = (item) => {
      const data=`${API_BASE_URL}${API_PATHS.trialbalancepdf}/${toDate}/${fromDate}/${profile_id}`
        navigate('/Pdf-Viewer', { state: { data } });
    };
  

    const handleFromDateChange = (e) => {
      const newDate = e.target.value;
      if (newDate >= minDate && newDate <= maxDate) {
        setFromDate(newDate);
        localStorage.setItem('savedFromDate', newDate);
      } else {
           toast.error(`Select a date within the financial year ${formatFinancialYear(minDate, maxDate)}`);
      }
    };
    
    const handleToDateChange = (e) => {
      const newDate = e.target.value;
      if (newDate >= minDate && newDate <= maxDate) {
        setToDate(newDate);
        localStorage.setItem('savedToDate', newDate);
      } else {
           toast.error(`Select a date within the financial year ${formatFinancialYear(minDate, maxDate)}`);
      }
    };

    const formatFinancialYear = (startDate, endDate) => {
      return `(${startDate.split("-").reverse().join("-")} to ${endDate.split("-").reverse().join("-")})`;
    };


    const goToGroupLedger = (groupName) => {
      if (groupName) {
        navigate(`/group-ledgers/${encodeURIComponent(groupName)}`);
      }
    };
  return (
    <AdminLayout>
      {isLoading && <Loader />}
      <div className="row content-body">
        <div className="container-fluid">
          <div className="page-header">
            <div>
              <h2 class="main-content-title tx-24 mg-b-5">Trial Balance</h2>
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="#">Reports</a>
                </li>
                <li class="breadcrumb-item active" aria-current="page">
                  Trial Balance
                </li>
              </ol>
            </div>
          </div>

          <div class="row mb-4">
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-12">
                  <div class="card custom-card">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-md-3 form-inline">
                          <div class="form-group">
                            <label class="">From Date</label>
                            <input class="form-control" type="date" value={fromDate} onChange={handleFromDateChange} min={minDate} max={maxDate} />
                          </div>
                        </div>
                        <div class="col-md-3 form-inline">
                          <div class="form-group">
                            <label class="">To Date</label>
                            <input class="form-control" type="date" value={toDate} onChange={handleToDateChange} min={minDate} max={maxDate}  />
                          </div>
                        </div>
                        <div class="col-md-5 form-inline">
                          <div class="form-group">
                            <button type="submit" class="btn btn-default" onClick={() => handleTrialBalance()}>
                              Submit
                            </button>
                          </div>
                          <div class="form-group">
                            <button type="button" className="btn btn-default" onClick={resetDates}>
                              Reset Date
                            </button>
                          </div>
                          <div class="form-group">
                       <button type="button" className="btn btn-default" onClick={handlePDF}>
                       Trial Balance PDF
                        </button>
                         </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-md-12">
                  <div className="card custom-card">
                    <div className="card-body">
                      {/* Trial Balance Table */}
                      <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                        <h3 style={{ fontWeight: '700' }} className="text-capitalize">
                          {Name}
                        </h3>
                        <h4 style={{ fontWeight: '700' }}>Trial Balance</h4>
                        <p>{formatDateRange(fromDate, toDate)}</p>
                      </div>
                      <table className="table">
                        <thead>
                          <tr style={{ BorderBottom: '2px solid black' }}>
                            <th>Particulars</th>
                            <th style={{ textAlign: 'right', width: '125px' }}>Dr</th>
                            <th style={{ textAlign: 'right', width: '125px' }}>Cr</th>
                          </tr>
                        </thead>
                        <tbody>
                          {Object.entries(trialBalance)?.map(([group, items]) => (
                            <React.Fragment key={group}>
                              <tr>
                                <td style={{ textAlign: 'left', fontWeight: 'bold', border: 'none',cursor:"pointer" }} onClick={()=>goToGroupLedger(group)}>{group}</td>
                                <td style={{ border: 'none', fontWeight: 'bold', textAlign: 'right', paddingRight: '0px' }}>
                                  {items?.reduce((sum, item) => {
                                    const debitValue = Number(item?.debit?.toString()?.replace(/,/g, '')); // Remove commas if any
                                    return isNaN(debitValue) ? sum : sum + debitValue;
                                  }, 0) > 0
                                    ? '₹' +
                                      items
                                        ?.reduce((sum, item) => {
                                          const debitValue = Number(item?.debit?.toString()?.replace(/,/g, ''));
                                          return isNaN(debitValue) ? sum : sum + debitValue;
                                        }, 0)
                                        ?.toLocaleString('en-IN', { minimumFractionDigits: 2 }) // Indian formatting with commas
                                    : ''}
                                </td>
                                <td style={{ border: 'none', fontWeight: 'bold', textAlign: 'right', paddingRight: '0px' }}>
                                  {items?.reduce((sum, item) => {
                                    const creditValue = Number(item?.credit?.toString()?.replace(/,/g, '')); // Remove commas if any
                                    return isNaN(creditValue) ? sum : sum + creditValue;
                                  }, 0) > 0
                                    ? '₹' +
                                      items
                                        ?.reduce((sum, item) => {
                                          const creditValue = Number(item?.credit?.toString()?.replace(/,/g, ''));
                                          return isNaN(creditValue) ? sum : sum + creditValue;
                                        }, 0)
                                        ?.toLocaleString('en-IN', { minimumFractionDigits: 2 })
                                    : ''}
                                </td>
                              </tr>
                            </React.Fragment>
                          ))}

                          <tr>
                            <td className="td1" style={{ borderTop: '1px solid', borderBottom: '1px solid' }}>
                              <b>Total</b>
                            </td>
                            <td className="td2" style={{ borderTop: '1px solid', borderBottom: '1px solid', textAlign: 'right', paddingRight: '0px' }}>
                              ₹
                              {typeof totaldebits === 'string'
                                ? parseFloat(totaldebits.replace(/,/g, '')).toLocaleString('en-IN', { minimumFractionDigits: 2 })
                                : parseFloat(totaldebits || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                            </td>
                            <td className="td2" style={{ borderTop: '1px solid', borderBottom: '1px solid', textAlign: 'right', paddingRight: '0px' }}>
                              ₹
                              {typeof totalcredits === 'string'
                                ? parseFloat(totalcredits.replace(/,/g, '')).toLocaleString('en-IN', { minimumFractionDigits: 2 })
                                : parseFloat(totalcredits || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default TrialBalance;
